import React from "react";
import { Navigate } from "react-router-dom";
//导入react-redux
import { useSelector } from "react-redux";

//react路由守卫
export default function RouterGuard(Component: any) {
    const isLogin = useSelector((state: any) => state.user.userInfo.token);
    if (isLogin) {
        return Component;
    }else{
        return <Navigate to="explorer/home" replace={true} />;
    }
}



